module.exports = __webpack_public_path__ + "static/media/eye.6c70855f.svg";